export const fieldData: {
    type: string;
    id: string;
    fields: {
        key: string;
        /**
         * Number 号码
         * Text 文本
         * Date 日期
         * Count 数字
         */
        type: 'Number' | 'Text' | 'Date' | 'Count';
        desc?: string;
        mainTip?: string;
        fullTip?: string;
    }[];
}[] = [
    {
        type: 'numberAndText',
        id: 'hrefNumAndText',
        fields: [
            { key: 'PN', type: 'Number' },
            { key: 'APNO', type: 'Number' },
            { key: 'PRNO', type: 'Number' },
            { key: 'KD', type: 'Number' },
            { key: 'PCT_PN', type: 'Number' },
            { key: 'PCT_APNO', type: 'Number' },
            { key: 'FAM_ID', type: 'Number' },
            { key: 'IFAM_ID', type: 'Number' },
            { key: 'EFAM_ID', type: 'Number' },
            { key: 'TTL', type: 'Text' },
            { key: 'ABST', type: 'Text' },

            { key: 'CLMS', type: 'Text' },
            { key: 'ICLMS', type: 'Text' },

            { key: 'DESC', type: 'Text' },
            { key: 'DESC_F', type: 'Text' },
            { key: 'DESC_B', type: 'Text' },
            { key: 'DESC_S', type: 'Text' },
            { key: 'DESC_D', type: 'Text' },
            { key: 'DESC_E', type: 'Text' },
            { key: 'PROBLEM_SUM', type: 'Text' },
            { key: 'METHOD_SUM', type: 'Text' },
            { key: 'BENEFIT_SUM', type: 'Text' },
            { key: 'PROBLEM_PHR', type: 'Text' },
            { key: 'BENEFIT_PHR', type: 'Text' },

            { key: 'TA', type: 'Text' },
            { key: 'TAC', type: 'Text' },
            { key: 'TACD', type: 'Text' },
            { key: 'MAINF', type: 'Text' },

            { key: 'TTL_ENTRANS', type: 'Text' },
            { key: 'ABST_ENTRANS', type: 'Text' },
            { key: 'CLMS_ENTRANS', type: 'Text' },
            { key: 'ICLMS_ENTRANS', type: 'Text' },
            { key: 'DESC_ENTRANS', type: 'Text' },

            { key: 'TTL_CNTRANS', type: 'Text' },
            { key: 'ABST_CNTRANS', type: 'Text' },
            { key: 'CLMS_CNTRANS', type: 'Text' },
            { key: 'ICLMS_CNTRANS', type: 'Text' },
            { key: 'DESC_CNTRANS', type: 'Text' },

            { key: 'TTL_JPTRANS', type: 'Text' },
            { key: 'ABST_JPTRANS', type: 'Text' },
            { key: 'CLMS_JPTRANS', type: 'Text' },
            { key: 'DESC_JPTRANS', type: 'Text' },

            { key: 'TTL_ALL', type: 'Text' },
            { key: 'ABST_ALL', type: 'Text' },
            { key: 'CLMS_ALL', type: 'Text' },
            { key: 'ICLMS_ALL', type: 'Text' },
            { key: 'DESC_ALL', type: 'Text' },

            { key: 'TA_ALL', type: 'Text' },
            { key: 'TAC_ALL', type: 'Text' },
            { key: 'TACD_ALL', type: 'Text' },
            { key: 'MAINF_ALL', type: 'Text' }
        ]
    },
    {
        type: 'companyAndPeople',
        id: 'hrefCompanyAndPerson',
        fields: [
            { key: 'ALL_AN', type: 'Text' },
            { key: 'AN', type: 'Text' },
            { key: 'ANC', type: 'Text' },
            { key: 'ANS', type: 'Text' },
            { key: 'ANS_EXACT', type: 'Text' },
            { key: 'ANCS', type: 'Text' },
            { key: 'ANCS_EXACT', type: 'Text' },
            { key: 'AN_HIST', type: 'Text' },
            { key: 'GNAME', type: 'Text' },
            { key: 'AN_ADD', type: 'Text' },
            { key: 'AN_COUNTRY', type: 'Text' },
            { key: 'AN_PROVINCE', type: 'Text' },
            { key: 'AN_CITY', type: 'Text' },
            { key: 'AN_DISTRICT', type: 'Text' },
            { key: 'ANC_ADD', type: 'Text' },
            { key: 'ANC_COUNTRY', type: 'Text' },
            { key: 'ANC_PROVINCE', type: 'Text' },
            { key: 'ANC_CITY', type: 'Text' },
            { key: 'ANC_DISTRICT', type: 'Text' },
            { key: 'F_AN', type: 'Text' },
            { key: 'F_ANC', type: 'Text' },
            { key: 'ANS_TYPE', type: 'Text' },
            { key: 'ANCS_TYPE', type: 'Text' },
            { key: 'IN', type: 'Text' },
            { key: 'INC', type: 'Text' },
            { key: 'IN_EXACT', type: 'Text' },
            { key: 'IN_ADDRESS', type: 'Text' },
            { key: 'F_IN', type: 'Text' },
            { key: 'AT', type: 'Text' },
            { key: 'AT_C', type: 'Text' },
            { key: 'ATC', type: 'Text' },
            { key: 'ATCS', type: 'Text' },
            { key: 'ATCC', type: 'Text' },
            { key: 'ATC_VALUE', type: 'Count' },
            { key: 'PE', type: 'Text' },
            { key: 'AE', type: 'Text' },
            { key: 'AUTHORITY', type: 'Text' },
            { key: 'PRIORITY_COUNTRY', type: 'Text' },
            { key: 'EPDS', type: 'Text' },
            { key: 'AN_EN', type: 'Text' },
            { key: 'BI_USCC', type: 'Text' },
            { key: 'BI_RN', type: 'Number' },
            { key: 'BI_ADD', type: 'Text' },
            { key: 'BI_ET', type: 'Text' },
            { key: 'BI_ED', type: 'Number' },
            { key: 'BI_RS', type: 'Text' },
            { key: 'LC_CODE', type: 'Number' },
        ]
    },
    {
        type: 'dateAndCategory',
        id: 'hrefDateAndClass',
        fields: [
            { key: 'APD', type: 'Date' },
            { key: 'APD_Y', type: 'Date' },
            { key: 'APD_YM', type: 'Date' },
            { key: 'PBD', type: 'Date' },
            { key: 'F_PBD', type: 'Date' },
            { key: 'PBD_Y', type: 'Date' },
            { key: 'PBD_YM', type: 'Date' },
            { key: 'EFAM_EPBD', type: 'Date' },
            { key: 'EFAM_EPBY', type: 'Date' },
            { key: 'EFAM_EPBYM', type: 'Date' },
            { key: 'EFAM_EPRD', type: 'Date' },
            { key: 'ISD', type: 'Date' },
            { key: 'EXPD', type: 'Date' },
            { key: 'EXAMINE_DATE', type: 'Date' },
            { key: 'PCTENTRY_DATE', type: 'Date' },
            { key: 'LEGAL_STATUS_DATE', type: 'Date' },
            { key: 'PRIORITY_DATE', type: 'Date' },
            { key: 'E_PRIORITY_DATE', type: 'Date' },
            { key: 'EXDT', type: 'Date' },
            { key: 'CLASS', type: 'Text' },
            { key: 'IPC', type: 'Text' },
            { key: 'IPC_SECTION', type: 'Text' },
            { key: 'IPC_CLASS', type: 'Text' },
            { key: 'IPC_SUB_CLASS', type: 'Text' },
            { key: 'IPC_GROUP', type: 'Text' },
            { key: 'IPC_SUB_GROUP', type: 'Text' },
            { key: 'MIPC', type: 'Text' },
            { key: 'MIPC_SECTION', type: 'Text' },
            { key: 'MIPC_CLASS', type: 'Text' },
            { key: 'MIPC_SUB_CLASS', type: 'Text' },
            { key: 'IPC_CPC', type: 'Text' },
            { key: 'CPC', type: 'Text' },
            { key: 'CPC_ALL', type: 'Text' },
            { key: 'CPC_SECTION', type: 'Text' },
            { key: 'CPC_CLASS', type: 'Text' },
            { key: 'CPC_SUB_CLASS', type: 'Text' },
            { key: 'CPC_GROUP', type: 'Text' },
            { key: 'CPC_SUB_GROUP', type: 'Text' },
            { key: 'MCPC', type: 'Text' },
            { key: 'GBC', type: 'Text' },
            { key: 'GBC_SECTION', type: 'Text' },
            { key: 'LOC', type: 'Text' },
            { key: 'UPC', type: 'Text' },
            { key: 'FI', type: 'Text' },
            { key: 'FTERM', type: 'Text' },

            { key: 'IPC_LOW', type: 'Text' },
            { key: 'MIPC_LOW', type: 'Text' },
            { key: 'CPC_LOW', type: 'Text' },
            { key: 'UPC_LOW', type: 'Text' },
            { key: 'FI_LOW', type: 'Text' },
            { key: 'FTERM_LOW', type: 'Text' },
            { key: 'ADC', type: 'Text' },
            { key: 'TTC', type: 'Text' },
            { key: 'SEIC', type: 'Text' },
            { key: 'SEIC_ALL', type: 'Text' }
        ]
    },
    {
        type: 'citeAndFamily',
        id: 'hrefCitationAndFam',
        fields: [
            { key: 'B_CITES', type: 'Number' },
            { key: 'F_CITES', type: 'Number' },
            { key: 'BF_CITES', type: 'Number' },
            { key: 'B_CITES_COUNT', type: 'Count' },
            { key: 'F_CITES_COUNT', type: 'Count' },
            { key: 'F_CITES_ANC', type: 'Text' },
            { key: 'B_CITES_ANC', type: 'Text'},
            { key: 'CITE_CATEGORY', type: 'Text' },
            { key: 'FAM', type: 'Number' },
            { key: 'IFAM', type: 'Number' },
            { key: 'EFAM', type: 'Number' },
            { key: 'FAM_COUNT', type: 'Count' },
            { key: 'IFAM_COUNT', type: 'Count' },
            { key: 'EFAM_COUNT', type: 'Count' },
            { key: 'EFAM_COUNTRY', type: 'Text' },
            { key: 'EFAM_EPB_COUNTRY', type: 'Text' },
            { key: 'FAM_COUNTRY', type: 'Text' },
            { key: 'FAM_COUNTRY_COUNT', type: 'Count' },
            { key: 'IFAM_COUNTRY_COUNT', type: 'Count' },
            { key: 'EFAM_COUNTRY_COUNT', type: 'Count' },
            { key: 'EPDS_COUNT', type: 'Count' },
        ]
    },
    {
        type: 'patentstatusAndQuality',
        id: 'hrefStatusAndQuality',
        fields: [
            { key: 'LEGAL_STATUS', type: 'Count' },
            { key: 'LEGAL_EVENT', type: 'Count' },
            { key: 'SIMPLE_LEGAL_STATUS', type: 'Count' },
            { key: 'EFAM_STATUS', type: 'Count' },
            { key: 'UP_STATUS', type: 'Count' },
            { key: 'ENTRY_COUNTRY_LS', type: 'Count' },
            { key: 'ENTRY_COUNTRY_SLS', type: 'Count' },
            { key: 'EPDS_LS', type: 'Count' },
            { key: 'EPDS_SLS', type: 'Count' },
            { key: 'PV', type: 'Count' },
            { key: 'PAGE_COUNT', type: 'Count' },
            { key: 'CLAIM_COUNT', type: 'Count' },
            { key: 'FCLMS_WORDCOUNT', type: 'Count' },
            { key: 'AN_COUNT', type: 'Count' },
            { key: 'ANC_COUNT', type: 'Count' },
            { key: 'IN_COUNT', type: 'Count' },
            { key: 'CPC_COUNT', type: 'Count' },
            { key: 'IPC_COUNT', type: 'Count' },
            { key: 'GOV', type: 'Text' },
            { key: 'EXAMINE_PERIOD', type: 'Count' },
            { key: 'PATENT_TYPE', type: 'Text' },
            { key: 'PCTENTRY_TYPE', type: 'Text' },
            { key: 'EP_ENTRY', type: 'Text' },
            { key: 'ENTRY_COUNTRY', type: 'Text' },
            { key: 'SEP', type: 'Count' },
            { key: 'SEP_NUMBER', type: 'Text' },
            { key: 'SEP_TITLE', type: 'Text' },
            { key: 'SEP_SOURCE', type: 'Text' },
            { key: 'SEP_PROJECT', type: 'Text' },
            { key: 'SEP_DECLARANT', type: 'Text' },
            { key: 'AWARD_NAME', type: 'Text' },
            { key: 'AWARD_LEVEL', type: 'Text' },
            { key: 'AWARD_SESSION', type: 'Text' },
            { key: 'SUB_CASE', type: 'Number' },
            { key: 'PRIORITY_COUNTRY_COUNT', type: 'Count' },
            { key: 'PRIORITY_EMPTY', type: 'Count' }
        ]
    },
    {
        type: 'litigation',
        id: 'hrefLegalLitigation',
        fields: [
            { key: 'LITIGATION', type: 'Count' },
            { key: 'CASENO', type: 'Text' },
            { key: 'COURT', type: 'Text' },
            { key: 'JUDGE', type: 'Text' },
            { key: 'CHIEF_JUDGE', type: 'Text' },
            { key: 'PLAINTIFF', type: 'Text' },
            { key: 'DEFENDANT', type: 'Text' },
            { key: 'FILING_DATE', type: 'Date' },
            { key: 'VERDICT_DATE', type: 'Date' },
            { key: 'HEARING_DATE', type: 'Date' },
            { key: 'TRIAL_GRADE', type: 'Text' },
            { key: 'CASE_NATURE', type: 'Text' },
            { key: 'CASE_LEVEL', type: 'Text' },
            { key: 'CASE_REGION', type: 'Text' },
            { key: 'CASE_TITLE', type: 'Text' },
            { key: 'CASE_FULL_TEXT', type: 'Text' },
            { key: 'LIT_CLOSEDT', type: 'Date' },
            { key: 'OUTCOME_JUDGEMENT', type: 'Text' },
            { key: 'OUTCOME_STATUS', type: 'Text' },
            { key: 'LITIGATION_COUNT', type: 'Count' },
            { key: 'CASE_DOC_TYPE', type: 'Text' },
            { key: 'COURT_GRADE', type: 'Text' },
            { key: 'VERDICT', type: 'Text' },
            { key: 'PARTY', type: 'Text' },
            { key: 'PARTY_AGENT', type: 'Text' },
            { key: 'PARTY_LAWFIRM', type: 'Text' },
            { key: 'AMOUNT_PLAINTIFF', type: 'Count' },
            { key: 'DAMAGES_AMOUNT', type: 'Count' },
            { key: 'FILING_YEAR', type: 'Date' },
            { key: 'LITIGATION_PRODUCT', type: 'Text' },
        ]
    },
    {
        type: 'licensing',
        id: 'hrefLegalLicensing',
        fields: [
            { key: 'LICENSE', type: 'Count' },
            { key: 'LICENSOR', type: 'Text' },
            { key: 'LICENSEE', type: 'Text' },
            { key: 'LICNO', type: 'Text' },
            { key: 'EXCLUSIVITY', type: 'Text' },
            { key: 'LIC_EFDT', type: 'Date' },
            { key: 'LICENSE_COUNT', type: 'Count' }
        ]
    },
    {
        type: 'assignment',
        id: 'hrefAssignment',
        fields: [
            { key: 'TRANSFER', type: 'Count' },
            { key: 'TRANSFER_BEFORE', type: 'Text' },
            { key: 'TRANSFER_AFTER', type: 'Text' },
            { key: 'TRANS_EFDT', type: 'Date' }
        ]
    },
    {
        type: 'reex',
        id: 'hrefReex',
        fields: [
            { key: 'REEXAMINVALID', type: 'Count' },
            { key: 'RI_APPLICANT', type: 'Text' },
            { key: 'RIDN', type: 'Text' },
            { key: 'RIIN', type: 'Text' },
            { key: 'RIDDT', type: 'Date' },
            { key: 'RIDTP', type: 'Text' },
            { key: 'RID', type: 'Text' },
            { key: 'RIDP', type: 'Text' },
            { key: 'RIDSM', type: 'Text' },
            { key: 'RILGS', type: 'Text' },
            { key: 'RI_FULL_TEXT', type: 'Text' },
            { key: 'INVALID_COUNT', type: 'Count' },
        ]
    },
    {
        type: 'pledge',
        id: 'hrefPledge',
        fields: [
            { key: 'PLEDGE', type: 'Count' },
            { key: 'PLEDGOR', type: 'Text' },
            { key: 'PLEDGEE', type: 'Text' },
            { key: 'PLEDGENO', type: 'Text' },
            { key: 'PLE_EFDT', type: 'Date' },
            { key: 'PLE_STAGE', type: 'Text' },
            { key: 'PLEDGE_COUNT', type: 'Count' }
        ]
    },
    {
        type: 'workspace',
        id: 'hrefWorkspace',
        fields: [
            { key: 'MWS', type: 'Text' },
            { key: 'CWS', type: 'Text' },
            { key: 'CCF_', type: 'Text' }
        ]
    }
];
